// src/pages/VolunteerApplicationPage.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';           // ✅ جدید
import { Loader2, Send, CheckCircle, ArrowRight } from 'lucide-react'; // ✅ ArrowRight اضافه شد
import { submitVolunteerApplication } from '../services/profileService';
import { goBack } from '../utils/navigation';          // ✅ جدید

const VolunteerApplicationPage = () => {
  const navigate = useNavigate();                         // ✅ جدید
  const [form, setForm] = useState({
    full_name: '',
    contact_info: '',
    area_of_interest: '',
    experience: '',
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    try {
      await submitVolunteerApplication(form);
      setMessage('درخواست شما با موفقیت ثبت شد. کارشناسان ما به زودی با شما تماس خواهند گرفت.');
      setForm({ full_name: '', contact_info: '', area_of_interest: '', experience: '' });
    } catch (err) {
      console.error(err);
      if (err.response?.status === 409) {
        setMessage('شما قبلاً یک درخواست فعال یا پذیرفته شده دارید.');
      } else {
        setMessage('خطا در ثبت درخواست. لطفاً مجدد تلاش کنید.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4 max-w-lg mx-auto rtl">
      {/* دکمهٔ بازگشت هوشمند */}
      <button
        type="button"
        onClick={() => goBack(navigate)}
        className="flex items-center text-indigo-600 hover:text-indigo-800 mb-4"
      >
        <ArrowRight size={18} className="ml-1" />
        بازگشت
      </button>

      <h1 className="text-2xl font-bold mb-4">همکاری داوطلبانه</h1>
      <p className="text-[11px] text-gray-600 mb-6">اگر تمایل به همکاری در زمینه‌های تولید محتوا، ترجمه، پژوهش و ... دارید، فرم زیر را تکمیل کنید.</p>

      {message ? (
        <div className="bg-green-50 text-green-700 p-4 rounded-xl text-center">
          <CheckCircle className="mx-auto mb-2" size={32} />
          <p>{message}</p>
          <button onClick={() => setMessage('')} className="mt-4 text-purple-700 underline text-[11px]">ارسال مجدد</button>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="bg-white rounded-xl shadow p-6 space-y-4">
          <div>
            <label className="block text-[11px] text-gray-600 mb-1">نام کامل *</label>
            <input
              name="full_name"
              value={form.full_name}
              onChange={handleChange}
              required
              className="w-full border border-gray-300 rounded-lg px-4 py-2"
            />
          </div>
          <div>
            <label className="block text-[11px] text-gray-600 mb-1">اطلاعات تماس (تلفن/ایمیل) *</label>
            <input
              name="contact_info"
              value={form.contact_info}
              onChange={handleChange}
              required
              className="w-full border border-gray-300 rounded-lg px-4 py-2"
            />
          </div>
          <div>
            <label className="block text-[11px] text-gray-600 mb-1">حوزه علاقه‌مندی *</label>
            <input
              name="area_of_interest"
              value={form.area_of_interest}
              onChange={handleChange}
              required
              className="w-full border border-gray-300 rounded-lg px-4 py-2"
              placeholder="مثلاً تولید محتوا، ترجمه..."
            />
          </div>
          <div>
            <label className="block text-[11px] text-gray-600 mb-1">سوابق یا توضیحات اضافی</label>
            <textarea
              name="experience"
              value={form.experience}
              onChange={handleChange}
              rows={4}
              className="w-full border border-gray-300 rounded-lg px-4 py-2"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-purple-700 text-white py-2 rounded-lg font-medium hover:bg-purple-800 transition flex items-center justify-center gap-2"
          >
            {loading ? <Loader2 className="animate-spin" size={18} /> : <Send size={18} />}
            ارسال درخواست
          </button>
        </form>
      )}
    </div>
  );
};

export default VolunteerApplicationPage;